module.exports = __webpack_public_path__ + "media/kommissar_1.0a.1da1c63d.mp3";